import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import ChessClubVisualizer from "./Home";
import AppRR from "./RRSRC/App";
import AppTVT from "./TVTSRC/App";
import AppTEAMSWISS from "./TEAM_SWISS/App";
import "./index.css";
import ChessClubVisualizerAHS from "./AHS";
import Mapguessr from "./map";
function App() {
  const location = useLocation();

  useEffect(() => {
    // Redirect to static swiss app
    if (location.pathname.startsWith('/swiss')) {
      window.location.href = '/swiss/index.html';
    }
  }, [location]);

  useEffect(() => {
    if (location.pathname === "/" || location.pathname === "/ahs") {
      document.body.className = "home-page";
    } else if (location.pathname.startsWith("/round-robin")) {
      document.body.className = "rr-page";
    }
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<ChessClubVisualizer />} />
      <Route path="/round-robin/*" element={<AppRR />} />
      <Route path="/team-1v1/*" element={<AppTVT />} />
      <Route path="/team-swiss/*" element={<AppTEAMSWISS />} />
      <Route path="/AHS/*" element={<ChessClubVisualizerAHS />} /> 
      <Route path="/borderline/*" element={<Mapguessr />} /> 
    </Routes>
  );
}

export default App;